import { observer } from 'mobx-react-lite'
import { useLocation } from 'react-router-dom'
import { Box, Typography } from 'shared/ui'
import { CreateSavedRepliesButton } from 'pages/settings/pages/savedReplies/ui/SavedRepliesAction'
import { SavedRepliesPath } from 'pages/settings/pages/savedReplies/route/savedRepliesPath'

export const SavedRepliesHeader = observer(() => {
  const location = useLocation()

  const isCreatePage = location.pathname === SavedRepliesPath.create

  return (
    <Box display='flex' justifyContent='space-between' marginBottom='36px'>
      <Box display='flex' flexDirection='column' gap='4px'>
        <Typography
          ariaLabel='Saved replies header'
          variant='heading-lg'
          color='var(--content-primary-primary)'
        >
          Saved replies
        </Typography>
        <Typography
          ariaLabel='Saved replies description'
          variant='body-md-regular'
          color='var(--content-primary-tertiary)'
        >
          Save time on common responses
        </Typography>
      </Box>
      <CreateSavedRepliesButton disabled={isCreatePage} />
    </Box>
  )
})
